const styles = (theme) => ({
  subheading: {
    fontSize: '1.125rem',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  label: {
    fontWeight: 500,
    display: 'block',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '180px',
      display: 'inline-block',
    },
  },
  value: {
    display: 'block',
    width: '100%',
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
    [theme.breakpoints.up('sm')]: {
      width: '180px',
      display: 'inline-block',
    },
  },
  changes: {
    textAlign: 'left',
    borderTop: `1px solid ${theme.palette.border.light}`,
    borderBottom: `1px solid ${theme.palette.border.light}`,
    padding: '15px 0',
  },
  dialogText: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  field: {
    marginBottom: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  confirmationText: {
    textAlign: 'left',
    padding: '15px 0 0 0',
  },
  avatar: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    color: theme.palette.primary.dark,
    borderRadius: '100px',
    boxSizing: 'content-box',
    padding: '15px',
    [theme.breakpoints.up('sm')]: {
      marginRight: '20px',
    },
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '0 0 10px 0',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      padding: '10px 0',
      justifyContent: 'flex-start',
    },
  },
});

export default styles;
